const Immutable = require('immutable')
const Slate = require('slate')
const createCell = require('./createCell')

/**
 * Create a new row block
 *
 * @param {Object} opts
 * @param {Number} columns
 * @param {Function} textGetter
 * @return {State.Block}
 */
function createRow (opts, columns, textGetter, data) {
  const cellNodes = Immutable.Range(0, columns)
        .map(i => createCell(opts, textGetter ? textGetter(i) : ''))
        .toList()

  return Slate.Block.create({
    type: opts.typeRow,
    nodes: cellNodes,
    data
  })
}

module.exports = createRow



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/deep-table-plugin/createRow.js